import {useQueryParams} from '@aboutyou/router';
import {AuthSearchParams} from '../../../../features/Authentication/hooks/constants';

export const useShouldShowCouponLoginBanner = () => {
  const queryParams = useQueryParams();
  let loginReason = queryParams.get(AuthSearchParams.LoginReason);
  const fromQueryParam = queryParams.get('from');

  if (!loginReason && fromQueryParam) {
    const decodedQueryParams = new URLSearchParams(
      decodeURIComponent(fromQueryParam).split('?')[1],
    );
    loginReason = decodedQueryParams.get(AuthSearchParams.LoginReason);
  }

  return loginReason === 'coupon';
};
